import { useState } from "react";
import { apiHandler } from "../../api";
import { endpoint } from "../../api/endpoint";
import { registrationValidation } from "../../utils/validationSchema/registrationValidation";
import { useToasts } from "react-toast-notifications";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

export const useRegistrationForm = ({ apiKey }) => {
  const { addToast } = useToasts();
  const [loading, setLoading] = useState(false);
  // const [apiKey, setApiKey] = useState(
  //   "d47628a848c2e6680feee3989f9676be8b65031036781b832c64bbd612a651a1"
  // );
  const [brandLogo, setBrandLogo] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [sessionId, setSessionId] = useState(null);
  const [sendLoader, setSendLoader] = useState(false);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const sendOtp = async () => {
    setOtpError("");

    try {
      setSendLoader(true);
      const response = await apiHandler({
        url: endpoint.SEND_OTP,
        method: "POST",
        data: {
          email,
        },
        dispatch,
      });

      if (response.data.success) {
        setSessionId(response.data.data.sessionId);
        toast.success("OTP sent successfully.");
        setOtpSent(true);
        setOtp("");
      } else {
        const data = response.data;
        setOtpError(data.message || "Failed to send OTP.");
      }
    } catch (err) {
      setOtpError("Network error.");
    } finally {
      setSendLoader(false);
    }
  };

  const verifyOtp = async () => {
    try {
      setVerifyLoader(true);
      const response = await apiHandler({
        url: endpoint.VERIFY_OTP,
        method: "POST",
        data: {
          email,
          otp,
          sessionId,
        },
        dispatch,
      });

      if (response.data.success) {
        toast.success("OTP verified successfully.");

        setOtpError("");
        setOtpVerified(true);
      } else {
        const data = await res.json();
        setOtpError(data.message || "Invalid OTP.");
      }
    } catch (err) {
      setOtpError("Network error.");
    } finally {
      setVerifyLoader(false);
    }
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files[0];

    if (!file) return;

    const validFormats = ["image/jpeg", "image/png"];
    let errorMsg = "";

    if (!validFormats.includes(file.type)) {
      errorMsg = "Brand Logo must be a PNG, JPG or JPEG file.";
    } else if (file.size > 2 * 1024 * 1024) {
      errorMsg = "Brand Logo must be less than 2MB.";
    } else {
      const img = new Image();
      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (img.width < 300 || img.height < 300) {
          setErrors((prevErrors) => ({
            ...prevErrors,
            brandLogo: "Brand Logo must be at least 300x300px.",
          }));
          return;
        }

        if (img.width < 500 || img.height < 500) {
      
        }

        setBrandLogo(file); // If valid, set logo
        setErrors((prevErrors) => ({ ...prevErrors, brandLogo: "" })); // Clear error
      };
      return;
    }

    setErrors((prevErrors) => ({ ...prevErrors, brandLogo: errorMsg })); // Store error in state
  };

  const dispatch = useDispatch();
  const handleBlur = (field, value) => {
    setErrors((prevErrors) => ({
      ...prevErrors,
      [field]: registrationValidation(value, getValidationRules(field)),
    }));
  };

  const getValidationRules = (field) => {
    const rules = {
      brandName: [
        { type: "required", name: "Brand Name" },
        { type: "minLength", name: "Brand Name", length: 3 },
        { type: "maxLength", name: "Brand Name", length: 50 },
      ],
      username: [
        { type: "required", name: "Username" },
        { type: "minLength", name: "Username", length: 3 },
        { type: "maxLength", name: "Username", length: 20 },
      ],
      email: [
        { type: "required", name: "Email" },
        { type: "email", name: "Email" },
      ],
      phone: [
        { type: "required", name: "Phone Number" },
        { type: "phone", name: "Phone Number" },
      ],
      brandLogo: [
        { type: "required", name: "Brand Logo" },
        { type: "imageFile", name: "Brand Logo" },
      ],
    };
    return rules[field] || [];
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const fieldValues = {
      brandName,
      username,
      email,
      brandLogo,
    };

    let newErrors = {};
    ["brandName", "username", "email", "brandLogo"].forEach((field) => {
      newErrors[field] = registrationValidation(
        fieldValues[field],
        getValidationRules(field)
      );
    });

    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) {
      return;
    }

    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("apiKey", apiKey);
      formData.append("sEmail", email);
      formData.append("sBrandName", brandName);
      formData.append("sBrandLogo", brandLogo);
      formData.append("sUserName", username);

      const response = await apiHandler({
        url: endpoint.COMPLETE_REGISTRATION,
        method: "POST",
        data: formData,
        headers: { "Content-Type": "multipart/form-data" },
        dispatch,
      });

      if (response.data.statusCode === 201) {
        addToast(response.data.message, {
          appearance: "success",
          autoDismiss: true,
        });

        window.location.href =
          `${response.data.data.cmsURL}/login` +
          `?auth=${JSON.stringify({
            accessToken: response.data.data.auth.accessToken,
            refreshToken: response.data.data.auth.refreshToken,
          })}&navbar=${JSON.stringify(
            response?.data?.data?.navbar
          )}&authorization=${JSON.stringify(
            response.data.data?.userDetails.authorization
          )}`;
      } else {
        addToast(response.data.message, {
          appearance: "error",
          autoDismiss: true,
        });
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return {
    brandLogo,
    setBrandLogo,
    brandName,
    setBrandName,
    username,
    setUsername,
    email,
    setEmail,
    handleLogoUpload,
    handleBlur,
    handleSubmit,
    errors,
    loading,
    otp,
    setOtp,
    sendOtp,
    verifyOtp,
    otpSent,
    otpVerified,
    otpError,
    setOtpSent,
    setOtpVerified,
    setOtpError,
    sendLoader,
    verifyLoader,
  };
};
